import React, { useState } from 'react';
import { FileTextIcon, CheckCircleIcon, XCircleIcon, ArrowRightIcon, ThumbsUpIcon, ThumbsDownIcon, SearchIcon, EyeIcon, SaveIcon } from 'lucide-react';
// Sample training data
const sampleTrainingDocuments = [{
  id: 'train-001',
  documentType: 'Invoice',
  vendor: 'Office Depot',
  date: '2023-09-15',
  status: 'Needs Review',
  confidence: 0.82,
  fields: [{
    name: 'invoiceNumber',
    expected: 'INV-2023-4501',
    extracted: 'INV-2023-4501',
    correct: true
  }, {
    name: 'invoiceDate',
    expected: '2023-09-15',
    extracted: '2023-09-15',
    correct: true
  }, {
    name: 'vendorName',
    expected: 'Office Depot',
    extracted: 'Office Depot',
    correct: true
  }, {
    name: 'vendorAddress',
    expected: '123 Business Ave, Suite 100, San Francisco, CA 94107',
    extracted: '123 Busines Ave, Suite 100, San Francisco, CA 94107',
    correct: false
  }, {
    name: 'total',
    expected: '1250.75',
    extracted: '1250.75',
    correct: true
  }],
  imageUrl: 'https://templates.invoicehome.com/invoice-template-us-neat-750px.png'
}, {
  id: 'train-002',
  documentType: 'Credit Note',
  vendor: 'Dell Technologies',
  date: '2023-09-10',
  status: 'Needs Review',
  confidence: 0.75,
  fields: [{
    name: 'creditNoteNumber',
    expected: 'CN-2023-102',
    extracted: 'CN-2023-102',
    correct: true
  }, {
    name: 'creditNoteDate',
    expected: '2023-09-10',
    extracted: '2023-09-10',
    correct: true
  }, {
    name: 'vendorName',
    expected: 'Dell Technologies',
    extracted: 'Dell Technoloqies',
    correct: false
  }, {
    name: 'total',
    expected: '430.00',
    extracted: '430.00',
    correct: true
  }, {
    name: 'reason',
    expected: 'Returned Items',
    extracted: 'Retumed Items',
    correct: false
  }],
  imageUrl: 'https://templates.invoicehome.com/invoice-template-us-neat-750px.png'
}, {
  id: 'train-003',
  documentType: 'Invoice',
  vendor: 'PrintWorks Inc.',
  date: '2023-09-05',
  status: 'Reviewed',
  confidence: 0.88,
  fields: [{
    name: 'invoiceNumber',
    expected: 'INV-PW-5782',
    extracted: 'INV-PW-5782',
    correct: true
  }, {
    name: 'invoiceDate',
    expected: '2023-09-05',
    extracted: '2023-09-05',
    correct: true
  }, {
    name: 'vendorName',
    expected: 'PrintWorks Inc.',
    extracted: 'PrintWorks Inc.',
    correct: true
  }, {
    name: 'vendorAddress',
    expected: '456 Print Street, Chicago, IL 60601',
    extracted: '456 Print Street, Chicago, IL 60601',
    correct: true
  }, {
    name: 'total',
    expected: '3200.50',
    extracted: '3200.50',
    correct: true
  }],
  imageUrl: 'https://templates.invoicehome.com/invoice-template-us-neat-750px.png'
}];
export function DITraining({
  locale = 'en-US'
}) {
  const [trainingDocuments, setTrainingDocuments] = useState(sampleTrainingDocuments);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [showingImage, setShowingImage] = useState(false);
  // Filter documents based on search and status filter
  const filteredDocuments = trainingDocuments.filter(doc => {
    const matchesSearch = doc.vendor.toLowerCase().includes(searchTerm.toLowerCase()) || doc.documentType.toLowerCase().includes(searchTerm.toLowerCase()) || doc.id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'All' || doc.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  // Handle document selection
  const handleSelectDocument = document => {
    setSelectedDocument(document);
    setShowingImage(false);
  };
  // Handle marking a field as correct
  const handleMarkFieldCorrect = (fieldIndex, isCorrect) => {
    if (!selectedDocument) return;
    const updatedFields = [...selectedDocument.fields];
    updatedFields[fieldIndex] = {
      ...updatedFields[fieldIndex],
      correct: isCorrect
    };
    const updatedDocument = {
      ...selectedDocument,
      fields: updatedFields
    };
    setSelectedDocument(updatedDocument);
    // Update the document in the list
    setTrainingDocuments(trainingDocuments.map(doc => doc.id === selectedDocument.id ? updatedDocument : doc));
  };
  // Handle saving training results
  const handleSaveTraining = () => {
    if (!selectedDocument) return;
    // In a real app, this would send the training data to an API
    const updatedDocuments = trainingDocuments.map(doc => doc.id === selectedDocument.id ? {
      ...selectedDocument,
      status: 'Reviewed'
    } : doc);
    setTrainingDocuments(updatedDocuments);
    setSelectedDocument({
      ...selectedDocument,
      status: 'Reviewed'
    });
    alert('Training data saved successfully');
  };
  // Toggle between document details and image view
  const toggleImageView = () => {
    setShowingImage(!showingImage);
  };
  return <div className="mb-8" data-id="element-4548">
      <div className="flex justify-between items-center mb-6" data-id="element-4549">
        <div data-id="element-4550">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-4551">DI Training</h2>
          <p className="mt-1 text-sm text-gray-500" data-id="element-4552">
            Review and correct Document Intelligence results to improve
            extraction accuracy
          </p>
        </div>
      </div>
      {/* Filters */}
      <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-6" data-id="element-4553">
        <div className="px-4 py-5 sm:p-6" data-id="element-4554">
          <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-4555">
            <div className="sm:col-span-3" data-id="element-4556">
              <label htmlFor="search" className="block text-sm font-medium text-gray-700" data-id="element-4557">
                Search
              </label>
              <div className="mt-1 relative rounded-md shadow-sm" data-id="element-4558">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-4559">
                  <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-4560" />
                </div>
                <input type="text" name="search" id="search" className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md" placeholder="Search by vendor or document type" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-4561" />
              </div>
            </div>
            <div className="sm:col-span-3" data-id="element-4562">
              <label htmlFor="status-filter" className="block text-sm font-medium text-gray-700" data-id="element-4563">
                Status
              </label>
              <select id="status-filter" name="status-filter" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-4564">
                <option value="All" data-id="element-4565">All</option>
                <option value="Needs Review" data-id="element-4566">Needs Review</option>
                <option value="Reviewed" data-id="element-4567">Reviewed</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-4568">
        {/* Documents List */}
        <div className="lg:col-span-1" data-id="element-4569">
          <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-4570">
            <div className="px-4 py-5 border-b border-gray-200 sm:px-6" data-id="element-4571">
              <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-4572">
                Training Documents
              </h3>
            </div>
            {filteredDocuments.length === 0 ? <div className="px-4 py-5 sm:p-6 text-center" data-id="element-4573">
                <p className="text-gray-500" data-id="element-4574">No documents match your filters</p>
              </div> : <ul className="divide-y divide-gray-200" data-id="element-4575">
                {filteredDocuments.map(document => <li key={document.id} className={`px-4 py-4 hover:bg-gray-50 cursor-pointer ${selectedDocument?.id === document.id ? 'bg-indigo-50' : ''}`} onClick={() => handleSelectDocument(document)} data-id="element-4576">
                    <div className="flex items-center justify-between" data-id="element-4577">
                      <div className="flex items-center" data-id="element-4578">
                        <FileTextIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-4579" />
                        <span className="text-sm font-medium text-gray-900" data-id="element-4580">
                          {document.vendor}
                        </span>
                      </div>
                      <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${document.status === 'Reviewed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-4581">
                        {document.status}
                      </div>
                    </div>
                    <div className="mt-2 flex justify-between" data-id="element-4582">
                      <div className="text-sm text-gray-500" data-id="element-4583">
                        {document.documentType} • {document.date}
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-4584">
                        {Math.round(document.confidence * 100)}% accurate
                      </div>
                    </div>
                  </li>)}
              </ul>}
          </div>
        </div>
        {/* Document Details */}
        <div className="lg:col-span-2" data-id="element-4585">
          {selectedDocument ? <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-4586">
              <div className="px-4 py-5 border-b border-gray-200 sm:px-6" data-id="element-4587">
                <div className="flex justify-between items-center" data-id="element-4588">
                  <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-4589">
                    {showingImage ? 'Document Image' : 'Field Comparison'}
                  </h3>
                  <button type="button" onClick={toggleImageView} className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-4590">
                    <EyeIcon className="h-4 w-4 mr-1" data-id="element-4591" />
                    {showingImage ? 'Show Fields' : 'Show Image'}
                  </button>
                </div>
              </div>
              {showingImage ? <div className="p-4 flex justify-center" data-id="element-4592">
                  <img src={selectedDocument.imageUrl} alt="Document" className="max-w-full h-auto shadow-md" data-id="element-4593" />
                </div> : <div className="px-4 py-5 sm:p-6" data-id="element-4594">
                  <div className="mb-4" data-id="element-4595">
                    <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-4596">
                      Document Information
                    </h4>
                    <dl className="grid grid-cols-2 gap-4" data-id="element-4597">
                      <div data-id="element-4598">
                        <dt className="text-sm font-medium text-gray-500" data-id="element-4599">
                          Document Type
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900" data-id="element-4600">
                          {selectedDocument.documentType}
                        </dd>
                      </div>
                      <div data-id="element-4601">
                        <dt className="text-sm font-medium text-gray-500" data-id="element-4602">
                          Vendor
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900" data-id="element-4603">
                          {selectedDocument.vendor}
                        </dd>
                      </div>
                      <div data-id="element-4604">
                        <dt className="text-sm font-medium text-gray-500" data-id="element-4605">
                          Date
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900" data-id="element-4606">
                          {selectedDocument.date}
                        </dd>
                      </div>
                      <div data-id="element-4607">
                        <dt className="text-sm font-medium text-gray-500" data-id="element-4608">
                          Confidence
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900" data-id="element-4609">
                          {Math.round(selectedDocument.confidence * 100)}%
                        </dd>
                      </div>
                    </dl>
                  </div>
                  <div className="mt-6" data-id="element-4610">
                    <h4 className="text-sm font-medium text-gray-900 mb-4" data-id="element-4611">
                      Field Comparison
                    </h4>
                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" data-id="element-4612">
                      <table className="min-w-full divide-y divide-gray-300" data-id="element-4613">
                        <thead className="bg-gray-50" data-id="element-4614">
                          <tr data-id="element-4615">
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6" data-id="element-4616">
                              Field
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-4617">
                              Expected
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-4618">
                              Extracted
                            </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-4619">
                              Status
                            </th>
                            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6" data-id="element-4620">
                              <span className="sr-only" data-id="element-4621">Actions</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white" data-id="element-4622">
                          {selectedDocument.fields.map((field, index) => <tr key={field.name} className={field.correct ? '' : 'bg-red-50'} data-id="element-4623">
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" data-id="element-4624">
                                {field.name}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" data-id="element-4625">
                                {field.expected}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" data-id="element-4626">
                                {field.extracted}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm" data-id="element-4627">
                                {field.correct ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-4628">
                                    <CheckCircleIcon className="h-4 w-4 mr-1" data-id="element-4629" />
                                    Correct
                                  </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-4630">
                                    <XCircleIcon className="h-4 w-4 mr-1" data-id="element-4631" />
                                    Incorrect
                                  </span>}
                              </td>
                              <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6" data-id="element-4632">
                                <div className="flex space-x-2 justify-end" data-id="element-4633">
                                  <button type="button" onClick={() => handleMarkFieldCorrect(index, true)} className={`text-green-600 hover:text-green-900 ${field.correct ? 'opacity-50 cursor-not-allowed' : ''}`} disabled={field.correct} data-id="element-4634">
                                    <ThumbsUpIcon className="h-4 w-4" data-id="element-4635" />
                                  </button>
                                  <button type="button" onClick={() => handleMarkFieldCorrect(index, false)} className={`text-red-600 hover:text-red-900 ${!field.correct ? 'opacity-50 cursor-not-allowed' : ''}`} disabled={!field.correct} data-id="element-4636">
                                    <ThumbsDownIcon className="h-4 w-4" data-id="element-4637" />
                                  </button>
                                </div>
                              </td>
                            </tr>)}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="mt-6 flex justify-end" data-id="element-4638">
                    <button type="button" onClick={handleSaveTraining} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" disabled={selectedDocument.status === 'Reviewed'} data-id="element-4639">
                      <SaveIcon className="h-4 w-4 mr-2" data-id="element-4640" />
                      Save Training
                    </button>
                  </div>
                </div>}
            </div> : <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-4641">
              <div className="px-4 py-5 sm:p-6 text-center" data-id="element-4642">
                <FileTextIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-4643" />
                <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-4644">
                  No document selected
                </h3>
                <p className="mt-1 text-sm text-gray-500" data-id="element-4645">
                  Select a document from the list to review and train Document
                  Intelligence results
                </p>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}